import { useSiteSettingsContext } from '@core/shared/src/components/SiteSettingsProvider';
import { OptionsApi } from '@core/swagger-client';
import { ContainerNoTopSpace, ContainerWebinarInner, ErrorMessagePage } from '@core/ui';
import { useParams, useRememberPage } from '@online-webinar/router';
import { BackToOriginLink } from '@online-webinar/ui-frontend';
import { useQuery } from '@tanstack/react-query';
import ContentLoader from 'react-content-loader';
import { useTranslation } from 'react-i18next';
import { ListWebinarContent } from '../../organisms/ListWebinarContent';

export const WebinarContent = () => {
    const isWhitelabel = useSiteSettingsContext().isWhitelabel;
    const { webinarId }: { webinarId: string } = useParams({ strict: false });
    const { t } = useTranslation();
    useRememberPage('content', `/${webinarId}/content`);

    const { isLoading, data: webinar, error } = useQuery(OptionsApi.dashboard.getContentSummary(webinarId!));

    if (error) {
        return <ErrorMessagePage apiError={error} />;
    }

    return (
        <ContainerNoTopSpace>
            <ContainerWebinarInner>
                <BackToOriginLink fallback="overview" />
                {!isLoading && webinar && <ListWebinarContent webinar={webinar} isWhitelabel={isWhitelabel} />}
                {isLoading && (
                    <ContentLoader speed={2} width={1250} height={300} backgroundColor="#C0C0C0" foregroundColor="#ecebeb">
                        <rect x="70" y="5" width="280" height="20" />
                        <rect x="70" y="40" width="280" height="12" />
                        <rect x="70" y="70" width="280" height="12" />
                        <rect x="70" y="100" width="280" height="12" />
                        <rect x="70" y="130" width="500" height="12" />
                        <rect x="70" y="160" width="200" height="30" />
                    </ContentLoader>
                )}
            </ContainerWebinarInner>
        </ContainerNoTopSpace>
    );
};
